<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Campaign Field</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign-fields'"
                @event-name="selectCampaign"
              ></CampaignAutocomplete>
            </div>
            <span class="text-danger text-sm mt-2">{{
              please_choose_campaign
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="fields.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="fields.description"
                v-validate="'required'"
                data-vv-as="Fields Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Level:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="fields.level"
                :vs-value="'account'"
                class="mr-4"
                vs-name="level"
                >Account</vs-radio
              >
              <vs-radio
                v-model="fields.level"
                :vs-value="'contact'"
                class="mr-4"
                vs-name="level"
                >Contact</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('level')"
              >{{ errors.first("level") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sales Developer Access:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="fields.sales_developer_access"
                :vs-value="'yes'"
                class="mr-4"
                vs-name="sales_developer_access"
                >Yes</vs-radio
              >
              <vs-radio
                v-model="fields.sales_developer_access"
                :vs-value="'no'"
                class="mr-4"
                vs-name="sales_developer_access"
                >No</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('sales_developer_access')"
              >{{ errors.first("sales_developer_access") }}</span
            >
          </div>
             <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Comments:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
            


  <vs-checkbox
                 v-model="fields.is_comments"
                 :vs-value="'yes'"
                 class="mr-4"
                 vs-name="is_comments"
               ></vs-checkbox>


            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('is_comments')"
              >{{ errors.first("is_comments") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="fields.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div
            class="vx-row mb-6"
            v-if="
              (fields.type && fields.type.value == 'dropdown') ||
                (fields.type && fields.type.value == 'checkbox') ||
                (fields.type && fields.type.value == 'choose_one')
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="chooseExistingList"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              (fields.type && fields.type.value == 'dropdown') ||
                (fields.type && fields.type.value == 'checkbox') ||
                (fields.type && fields.type.value == 'choose_one')
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Value:</span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="fields.value"
                data-vv-as="Value"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addValue" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="chooseExistingList">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-row vs-w="12" class="mb-5">
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
                  <FieldsAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox"
                    :list="searchExistingFieldLists"
                    :searchOn="'campaign-field'"
                    @event-name="handleChildEvent"
                  ></FieldsAutocomplete>

                  <!-- <v-select
                    class="mb-4"
                    label="name"
                    name="existing_list"
                    :options="existing_fields_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="fields.existing_list"
                  /> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="4"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>

              <div class="vx-col sm:w-1/2 w-full">
                <span v-for="elv in existing_list_values" class="p-2">
                  <vs-input
                    class="w-full"
                    name="existing_list_value"
                    v-model="elv.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeExistingListValues(elv)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <template v-if="fields.values && fields.values.length > 0">
              <div class="vx-col sm:w-1/5 w-full"></div>
            </template>

            <div class="vx-col sm:w-1/4 w-full">
              <template v-for="(v, index) in fields.values">
                <span :key="index" class="p-2">
                  <vs-input
                    class="w-full"
                    name="field_new_values"
                    v-model="v.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeSelectedValue(v)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </template>
            </div>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'campaignFields'" 
            ref="campaignFields"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import moduleMasterFieldsManagement from "@/store/fields-management/master-fields-management/moduleMasterFieldsManagement.js";
import FieldsAutocomplete from "@/components/autocomplete/FieldsAutocomplete.vue";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      companySearchComponentKey: 0,

      please_choose_options: null,
      chooseExistingList: false,
      columnDefs: [
        {
          headerName: "Campaign",
          field: "campaign_name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Name",
          field: "name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          width: 400,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
         {
        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Value",
          field: "values",
          width: 550,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Sales Developer Access",
          field: "sales_developer_access",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
         {
          headerName: "Is Comments",
          field: "is_comments",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      please_choose_campaign: null,
      selected_campaign: null,
      dataSource: {},
      records: [],
      selected: [],
      allFields: [],
      abilities: null,
      existing_list_values: [],
      existing_fields_list: [],
      fields: {
        values: [],
        name: null,
        description: null,
        level:'account',
        type: null,
        value: null,
        sales_developer_access: "yes",
        existing_list: null,
        selected_campaign_id: null,
        is_comments: false
      },
      types: [
        {
          name: "Text",
          value: "text"
        },
        {
          name: "Number",
          value: "number"
        },
        {
          name: "Textarea",
          value: "textarea"
        },
        {
          name: "Date",
          value: "date"
        },
        {
          name: "DateTime",
          value: "datetime"
        },
        {
          name: "Checkbox",
          value: "checkbox"
        },
        {
          name: "Dropdown",
          value: "dropdown"
        },
        {
          name: "Choose One",
          value: "choose_one"
        },
        {
          name: "Client Contact",
          value: "client_contact"
        }
      ]
    };
  },
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid,
    FieldsAutocomplete,
    CampaignAutocomplete,
    moduleCampaignManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }

    if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {
    this.getExistingFieldLists();
  },
  watch: {
    "fields.type.value": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    "fields.type": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    // "fields.existing_list": function(val) {
    //   if (val) {
    //     let filtered_value = this.existing_fields_list.filter(ele => {
    //       return ele.field_id == val.field_id;
    //     });
    //     if (filtered_value) {
    //       let lists = filtered_value[0];
    //       this.existing_list_values = JSON.parse(lists.values);
    //     }

    //     console.log(this.existing_list_values);
    //   }
    // },
    chooseExistingList: function(val) {
      if (val) {
        this.chooseExistingList = true;
        // this.existing_list_values = null
        // // let filtered_value = this.existing_fields_list.filter(ele => {
        // //   return ele.field_id == val.field_id;
        // // });
        // let filtered_value = this.existing_fields_list
        // if (filtered_value) {
        //   let lists = filtered_value[0];
        //   this.existing_list_values = JSON.parse(lists.values);
        // }

        // console.log(this.existing_list_values);
      } else {
        this.existing_list_values = [];
      }
    }
  },
  methods: {
    selectCampaign() {
      this.please_choose_campaign = null;
      this.selected_campaign = moduleCampaignManagement.state.selected_campaign;
    },
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    searchExistingFieldLists(inputValue) {
      let search_from = "campaign_field";
      return this.$store
        .dispatch("MasterFieldsManagement/searchExistingFieldLists", {
          search_from: search_from,
          inputValue: inputValue
        })
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              data = JSON.parse(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].field_id,
                  name: data[property].name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let selected_field = moduleCampaignFieldsManagement.state.selected_fields;

      console.log("EXis", this.existing_fields_list);

      if (selected_field) {
        let filtered_value = this.existing_fields_list.filter(ele => {
          return ele.field_id == selected_field.id;
        });

        console.log("Filtered", filtered_value);

        if (filtered_value) {
          let lists = filtered_value[0];
          this.existing_list_values = JSON.parse(lists.values);
        }

        console.log(this.existing_list_values);
      }
    },
    removeSelectedValue(value) {
      this.fields.values = this.fields.values.filter(item => {
        return item != value;
      });
    },
    removeExistingListValues(value) {
      this.existing_list_values = this.existing_list_values.filter(item => {
        return item != value;
      });
    },
    addValue() {
      if (this.fields.value && !this.fields.values.includes(this.fields.value))
        this.fields.values.push({
          value: this.fields.value
        });
      this.fields.value = null;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "CampaignFieldsManagement/getAllCampaignFields",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.campaignFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.campaignFields.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addFields();
        }
      });
    },
    addFields() {
      if (
        this.fields.type.value == "checkbox" ||
        this.fields.type.value == "dropdown" ||
        this.fields.type.value == "choose_one"
      ) {
        if (
          this.fields.values.length == 0 &&
          this.existing_list_values.length == 0
        ) {
          this.please_choose_options =
            "Atleast one options is required for " +
            this.fields.type.value +
            " list.";
          return false;
        }
      }

      let joined_values = [];
      joined_values = this.fields.values.concat(this.existing_list_values);
      joined_values = joined_values.filter(function(ele) {
        return ele != null;
      });
      this.fields.values = joined_values;

      if (
        typeof this.selected_campaign !== "undefined" &&
        this.selected_campaign !== null
      ) {
        this.fields.selected_campaign_id = this.selected_campaign.id;
      } else {
        this.please_choose_campaign = "The campaign field is required.";
        return false;
      }

      console.log(this.fields)

      this.$store
        .dispatch("CampaignFieldsManagement/addFields", this.fields)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Fields Exists",
              text: res.data.message
            });

            var uniq = {}
            this.fields.values = this.fields.values.filter(obj => !uniq[obj.value] && (uniq[obj.value] = true));
            console.log(this.fields.values)

          } else {
            this.$vs.notify({
              color: "success",
              title: "Fields Added",
              text: "The campaign fields was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/campaign-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getExistingFieldLists() {
      this.$store
        .dispatch(
          "CampaignFieldsManagement/getExistingFieldLists",
          "campaign_field"
        )
        .then(res => {
          console.log("LISTS", JSON.parse(res.data));
          let result = JSON.parse(res.data);
          if (result) {
            this.existing_fields_list = result;
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
